import React from "react";
import PortalPCAreaFilterCheckboxList from "./PortalPCAreaFilterCheckboxList";
import PortalPCResultBar from "./PortalPCResultBar";
import { NAGOYA_WARD_OPTIONS } from "../common/portalSearch";

function PortalPCResultHeader() {
  return (
    <div className="portalPcResultHeader">
      <h1 className="portalPcResultTitle">
        <i className="fa fa-filter" aria-hidden="true" />
        検索結果
      </h1>
      <PortalPCAreaFilterCheckboxList options={NAGOYA_WARD_OPTIONS} />
      <PortalPCResultBar />
    </div>
  );
}

export default PortalPCResultHeader;
